import { render } from "./StatsBanner.vue?vue&type=template&id=4bb95b4c"
import script from "./StatsBanner.vue?vue&type=script&lang=js"
export * from "./StatsBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__